module.exports = __webpack_public_path__ + "static/media/m_hairstyle_curly_front_shadow.daba6418.png";